import React, { useLayoutEffect } from 'react'
import { View } from 'react-native'

import { useMeasuredWidth } from '../../useMeasuredWidth'

export type Form = 'expanded' | 'collapsed'

type MeasureProps = {
    groupKey: string
    form: Form
    onWidth(groupKey: string, form: Form, width: number): void
    children: React.ReactNode
    testID: string
}

export const FilterSwitchMeasure = ({
    groupKey,
    form,
    onWidth,
    children,
    testID,
}: MeasureProps) => {
    const measured = useMeasuredWidth()
    useLayoutEffect(() => {
        if (measured.width > 0) {
            onWidth(groupKey, form, measured.width)
        }
    }, [measured.width, groupKey, form, onWidth])
    return (
        <View {...measured.props} className='shrink-0 self-start' testID={testID}>
            {children}
        </View>
    )
}
